<template>
  <div class="studies">
    <b-container fluid="xxl">
      <b-row class="text-center">
        <b-col>
          <input
            class="px-2 py-1 w-100"
            id="search"
            type="text"
            size="sm"
            placeholder="Search studies"
            @keyup="getSearchResults()"
            autocomplete="off"
            v-model="query"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <ul v-if="studies.length" class="results-ul">
            <li v-for="study in studies" :key="study.id">
              <a href="#" @click="selectStudy($event, study)" v-html="study.sigleLegam"></a>
            </li>
          </ul>
          <span v-else class="opacity-60">
            <span v-if="query">No results</span>
            <span v-else>Start searching</span>
          </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'StudyAutocomplete',
    props: ['exclude'],
    data() {
      this.$store.state.study.studies = []
      return {
        query: '',
        timer: null
      }
    },
    mounted() {
      this.$store.state.study.studies = []
    },
    computed: {
      ...mapState({
        studies: state => state.study.studies
      }),
      clearQuery(){
        return this.query.replace(/\*/gi, '')
      }
    },
    methods: {
      selectStudy(event, study){
        event.preventDefault()
        this.$emit('select', study)
        this.$store.state.study.studies = []
        this.query = ''
      },
      getSearchResults(){
        clearTimeout(this.timer)
        // let that = this
        this.timer = setTimeout(() => {
          this.$store.dispatch('searchStudies', {
            query: this.query.toLowerCase(),
            exclude: (this.exclude ? this.exclude : [])
          })
        }, 400)
      }
    }
  }
</script>
